import React from "react";
var __jsx = React.createElement;
var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
    children = _ref.children;
  //
  return /*#__PURE__*/React.createElement("div", {
    className: "relative group inline-block lg:z-30"
  }, children, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-1/2 bottom-full mb-2 w-max -translate-x-1/2 transform scale-0 rounded-lg bg-neutral-100 p-2 text-xs text-white opacity-0 shadow-lg transition-all group-hover:scale-100 group-hover:opacity-100"
  }, text, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-1/2 top-full -ml-1.5 h-3 w-3 rotate-45 bg-neutral-100 -mt-2"
  })));
};
export default Tooltip;